export default __webpack_public_path__ + "static/media/promo-banner-referral.a0bff851.svg";